import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CurrencyFilterBody = _resolveComponent("CurrencyFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    id: "currencies",
    ref: "currencyFilterItem",
    "no-count": "",
    title: $options.getCurrencyTitle,
    selectedTitle: $options.getCurrencySelectedTitle,
    selectedCount: $props.currencies?.filterState?.selectedCount,
    onClearAll: $options.onClear,
    onApply: $options.onApply,
    onHidden: $options.onHidden
  }, {
    body: _withCtx(() => [_createVNode(_component_CurrencyFilterBody, {
      title: "Currency",
      selected: $props.currencies?.filterState?.selected,
      isModified: $props.currencies.isModified,
      pendingChanges: $props.currencies.pendingChanges,
      isSearching: $props.currencies.isSearching,
      keyword: $props.currencies.keyword,
      list: $props.currencies.displayList,
      onClear: $options.onClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.onSelect,
      onSelectOnly: $options.onSelectOnly,
      onDeselect: $options.onDeSelect,
      onApply: $options.onApply,
      onSearch: $options.onSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: $options.onClose
    }, null, 8, ["selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onApply", "onSearch", "onHidden", "onCloseDropdown"])]),
    _: 1
  }, 8, ["title", "selectedTitle", "selectedCount", "onClearAll", "onApply", "onHidden"]);
}